import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from "react";
import { Popover as FluentPopover, PopoverTrigger, PopoverSurface, makeStyles, tokens } from "@fluentui/react-components";
import { Button } from "./button";
const useStyles = makeStyles({
    surface: {
        maxWidth: "400px",
    },
    content: {
        display: "flex",
        flexDirection: "column",
        gap: tokens.spacingVerticalM,
        padding: tokens.spacingHorizontalL,
        minWidth: "300px",
    },
});
export const Popover = forwardRef((props, ref) => {
    const { children, open: controlledOpen, onOpenChange, positioning, surfaceClassName } = props;
    const [internalOpen, setInternalOpen] = useState(false);
    const classes = useStyles();
    const isControlled = controlledOpen !== undefined;
    const popoverOpen = isControlled ? controlledOpen : internalOpen;
    const handleOpenChange = (_, data) => {
        if (!isControlled) {
            setInternalOpen(data.open);
        }
        onOpenChange?.(data.open);
    };
    return (_jsxs(FluentPopover, { open: popoverOpen, onOpenChange: handleOpenChange, positioning: positioning ?? {
            align: "start",
            overflowBoundary: document.body,
            autoSize: true,
        }, children: [_jsx(PopoverTrigger, { disableButtonEnhancement: true, children: props.trigger ?? _jsx(Button, { ref: ref, icon: props.icon, onClick: () => handleOpenChange(null, { open: true }) }) }), _jsx(PopoverSurface, { className: surfaceClassName ?? classes.surface, children: _jsx("div", { className: classes.content, children: children }) })] }));
});
Popover.displayName = "Popover";
//# sourceMappingURL=popover.js.map